module.exports = __webpack_public_path__ + "static/media/thumbnail-kiunyu-ab.1ca9202e.jpg";